import { render, staticRenderFns } from "./time.vue?vue&type=template&id=44707114"
import script from "./time.ts?vue&type=script&lang=js&external"
export * from "./time.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports